var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticStyle:{"width":"250px","height":"50px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }